import { createSelector } from 'reselect'

const baseSelector = ({ seatRequests }) => seatRequests

export const isSeatRequestModalOpenSelector = createSelector(baseSelector, ({ isModalOpen }) => isModalOpen)
export const isSeatRequestModalOnSubmitStepSelector = createSelector(baseSelector, ({ isOnSubmitStep }) => isOnSubmitStep)
export const seatRequestOrganizationSelector = createSelector(baseSelector, ({ organization }) => organization)
export const seatRequestBannerOpenedFromSelector = createSelector(baseSelector, ({ openedFrom }) => openedFrom)
